import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { InfoBannerComponent } from './registration/a2p-registration/info-banner/info-banner.component';
import { A2PRegistrationService } from './registration/a2p-registration/a2p-registration.service';
import { SmsRegistrationAlertComponent } from './registration/a2p-registration/sms-registration-alert/sms-registration-alert.component';
import { SmsRegistrationErrorBannerComponent } from './registration/a2p-registration/sms-registration-error-banner/sms-registration-error-banner.component';
import { BusinessCategoryToLabelPipe } from './registration/a2p-registration/sms-registration-form/pipes/business-category-to-label.pipe';
import { RegionToLabelPipe } from './registration/a2p-registration/sms-registration-form/pipes/region-to-label.pipe';
import { SmsRegistrationFormComponent } from './registration/a2p-registration/sms-registration-form/sms-registration-form.component';
import { SmsRegistrationComponent } from './registration/a2p-registration/sms-registration/sms-registration.component';
import { TranslateModule } from '@ngx-translate/core';
import { SMSI18NModule } from './assets/i18n/sms-i18n.module';
import { ProgressTrackerComponent } from './registration/progress-tracker/progress-tracker.component';
import { RegistrationService } from './registration/registration.service';
import { RegulationService } from './registration/regulatory-compliance/regulation.service';
import { OwnerService } from './common/owner.service';
import {
  SmsRegulatoryFormComponent
} from './registration/regulatory-compliance/regulatory-form/sms-regulatory-form.component';

@NgModule({
  declarations: [
    SmsRegistrationAlertComponent,
  ],
  exports: [SmsRegistrationComponent, SmsRegistrationAlertComponent, SmsRegulatoryFormComponent],
  imports: [
    CommonModule,
    MatCardModule,
    GalaxyFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    ReactiveFormsModule,
    BusinessCategoryToLabelPipe,
    RegionToLabelPipe,
    MatIconModule,
    InfoBannerComponent,
    GalaxyAlertModule,
    MatChipsModule,
    GalaxyBadgeModule,
    GalaxyPopoverModule,
    CdkOverlayOrigin,
    TranslateModule,
    SMSI18NModule,
    ProgressTrackerComponent,
    SmsRegulatoryFormComponent,
    SmsRegistrationComponent,
    SmsRegistrationFormComponent,
    SmsRegistrationErrorBannerComponent,
  ],
  providers: [A2PRegistrationService, RegistrationService, OwnerService, RegulationService],
})
export class SmsModule {}
